import ColumnsEditor from './columnsEditor';

export default ColumnsEditor;
